import StyledLocalLink from "features/shared/components/link/styles/StyledLocalLink.styled";
import styled from "styled-components";

const Links = styled.div`
  display: inline-flex;
  flex-direction: column;

  ${StyledLocalLink} {
    display: inline-block;
  }

  ${StyledLocalLink}:not(:first-child) {
    margin-top: 16px;
  }
`;

export default Links;
